import { useMutation } from '@tanstack/react-query'

import { deleteEvidence } from '@src/api'
import { DefaultApiDeleteEvidenceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteEvidence = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteEvidenceRequest) =>
      deleteEvidence(axiosInstance, params),
  })
}
